import React from 'react';
import { FaEdit,FaBan } from "react-icons/fa";
import { FiSlash } from "react-icons/fi";
import logo555Mix from "../../../assets/icons/555mix-logo.avif";
import logo909 from "../../../assets/icons/909.png";

const statusStyles = {
  ongoing: 'bg-customLightYellow2/30 text-customLightYellow text-xs',
  finished: 'bg-customFontLightGreen/10 dark:bg-customFontLightGreen/30 text-customDarkGreen text-xs',
  upcoming: 'bg-customMultiColor/30 text-customBlue text-xs',
  postpond: 'bg-customFontRed/10 dark:bg-customFontRed/30 text-customFontRed text-xs'
};

const ResultCard = ({ league, kickoff, fixtures,handleOpen,snapshotDetails }) => {
  const hasSnapshots = snapshotDetails.length > 0 && snapshotDetails.filter(item => item.status !== "PENDING").length > 0;
  const isWaitingStage = snapshotDetails[0]?.status === "WAITING";

  return (
    <div className={`z-0 relative flex h-full flex-col justify-between rounded-lg  ${hasSnapshots ? isWaitingStage ? 'border-2 border-customFontRed': 'border-2 border-customFontLightGreen' : 'border border-customLightMilkWhite dark:border-custom_dark_secondary shadow-sorting'} bg-white dark:bg-custom_dark_primary2`}>
      <div className="flex items-start justify-between px-3 pt-2">
        <div className='flex flex-col'>
        <span className="text-xs font-semibold text-customPrimaryText/80 dark:text-customMuted">{league}</span>
        <span className="text-xs font-normal dark:text-customMuted text-customSecondaryText">{kickoff}</span>
        </div>
        {
          hasSnapshots ?
          <FaEdit size={15} onClick={() => handleOpen(snapshotDetails,league,kickoff,fixtures)} 
          className='dark:text-customFontMilkWhite text-customBlack cursor-pointer' 
          /> : null
        }
      </div>
      <div className="flex flex-1 flex-col divide-y divide-customTitleColor dark:divide-custom_dark_secondary">
        {fixtures.map((fixture,i) => {
          return (
            <div key={fixture.id} className={`flex flex-1 flex-col px-3 py-1 ${i === 1 ? 'bg-customLightMilkWhite dark:bg-custom_dark_primary/40' : 'bg-white dark:bg-custom_dark_primary2'}`}>
              <div className="flex flex-col gap-1">
                <div className='flex justify-between'>
                <div className='flex gap-1 items-center'>
                <img src={ fixture.bookmaker === "555Mix" ? logo555Mix : logo909} alt="" width={i === 0 ? 15 : 12} height={'auto'}/>  
                <p className={`text-xs italic font-medium ${fixture.bookmaker === "555Mix" ? 'text-customDarkGreen' : 'text-customAccent'}`}>{fixture.bookmaker}</p>
                </div>
                <p className='text-xs font-medium dark:text-customMuted text-customSecondaryText'>{fixture.id}</p>
                </div>
                { fixture.id === 'null' ? null : <p className="text-paragraph font-semibold text-customPrimaryText dark:text-customLightMilkWhite">{fixture.matchup}</p>}
              </div>
              {
                fixture.id === 'null' ?
                  <div className='flex flex-col items-center justify-center'>
                    <FiSlash className='text-customBlack/40 dark:text-customMuted/50' size={30}/>
                    <span className='text-base text-customBlack/40 dark:text-customMuted/50 font-medium'>N/A</span>
                  </div>
                  : <div className="flex items-center justify-between">
                    <span className={`rounded-sm px-2 ${statusStyles[fixture.statusId] || 'bg-customLightMilkWhite text-customHeader'}`}>
                      {fixture.status}
                    </span>
                    <span className={`text-lg font-bold ${fixture.score === '-' ? 'text-customHeader' : 'text-customAccent'}`}>
                      {fixture.score}
                    </span>
                  </div>
              }
            </div>
          )
        })}
      </div>
      {
        hasSnapshots ?
          <div className={`absolute top-[-7px] right-0 px-1 rounded-full ${isWaitingStage ? 'bg-customFontRed' : 'bg-customFontLightGreen'} text-customFontMilkWhite font-semibold text-xs`}>
            <span>{snapshotDetails[0]?.status}</span>
          </div> : null
      }
    </div>
  );
};

export default ResultCard;

